import React, { useState, useEffect } from "react";
import firebase from 'firebase/compat/app';
import "firebase/database"
import { getAuth } from "firebase/auth";
import { Container, Row, Col, Button, Table, Alert, Modal } from "react-bootstrap";
import './FavoritedProducts.css';
import { FaTrashAlt } from 'react-icons/fa';

function FavoritedProducts() {

    const [show, setShow] = useState(false)

    const handleShow = () => setShow(true)
    const handleClose = () => setShow(false)

    const [favoriteList, setFavoriteList] = useState()
    const [alert, setAlert] = useState("")

    const auth = getAuth();
    const user = auth.currentUser;
    const uid = user.uid;


    useEffect(() => {
        const newFavoriteRef = firebase.database().ref(uid + "/favorites")
        // ovdje ispod je način kako čitamo podatke iz naše firebase liste
        newFavoriteRef.on("value", (snapshot) => {
            const favorites = snapshot.val()
            const favoriteList = []
            for (let id in favorites) {
                favoriteList.push({ id, ...favorites[id] })
            }
            setFavoriteList(favoriteList)
        })
    }, [uid])

    function emptyFavorites(event) {
        let favoritedRef = firebase.database().ref(uid + "/favorites");

        if (favoritedRef.remove()) {
            setAlert("Your list of favorites is now empty.")
        }
        setShow(false)
    }

    useEffect(() => {
        setTimeout(() => {
            setAlert(false);
        }, 2000);
    }, [alert]);

    return (
        <div>
            <Container id="list">
                <Row>
                    <Col>
                        <h4>Favorited products list</h4>
                        {alert && <Alert variant="danger">{alert}</Alert>}
                        <Table striped bordered hover variant="dark">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th className="text-colored">Product name</th>
                                    <th className="text-colored">Barcode</th>
                                    <th className="text-colored">Custom code</th>
                                </tr>
                            </thead>

                            <tbody>

                                {favoriteList ? favoriteList.map((favorite, index) => (
                                    <tr key={favorite.id}>
                                        <td className="text-colored">{index + 1}</td>
                                        <td>{favorite.productName}</td>
                                        <td>{favorite.barcode}</td>
                                        <td>{favorite.code}</td>
                                    </tr>
                                )) : <tr>{null}</tr>}


                            </tbody>
                        </Table>
                        <Button onClick={handleShow} className="empty-btn" variant="secondary"><FaTrashAlt className="icon" /> Delete all</Button>
                    </Col>
                </Row>
            </Container>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body">Are you sure you want to delete your products from favorites?</Modal.Body>
                <Modal.Footer>
                    <Button className="delete-btn-modal" variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button className="delete-btn-modal" variant="primary" onClick={emptyFavorites}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default FavoritedProducts